import { isEmailValid, isPhoneNumberValid } from "@hopper-b2b/utilities";
import { AirPriceFreezeContext } from "./context";

export const Guards = {
  contactContinue: (ctx: AirPriceFreezeContext, _event: unknown) => {
    const contactInfo = ctx["contactInformation"];
    return (
      contactInfo?.email &&
      contactInfo?.phoneNumber &&
      isEmailValid(contactInfo.email) &&
      isPhoneNumberValid(contactInfo.phoneNumber)
    );
  },
};
